"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useCardStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    root: {
      overflow: 'hidden'
    },
    depth1: {
      boxShadow: theme.shadows[1]
    },
    depth2: {
      boxShadow: theme.shadows[2]
    },
    depth3: {
      boxShadow: theme.shadows[3]
    },
    depth4: {
      boxShadow: theme.shadows[4]
    },
    depth5: {
      boxShadow: theme.shadows[5]
    },
    iconBox: {
      maxHeight: 24
    },
    cardHeader: {
      borderBottom: '1px solid #E0E0E0'
    },
    onlyHeader: {
      borderBottom: 'none'
    },
    noHeader: {
      display: 'none'
    },
    cardHeaderContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    title: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(24),
      margin: 0,
      color: theme.palette.NEUTRAL600
    },
    titleContainer: {
      display: 'flex'
    },
    subtitle: {
      color: theme.palette.NEUTRAL300,
      fontSize: theme.typography.pxToRem(16),
      marginTop: theme.spacing(1)
    },
    footer: {
      backgroundColor: theme.palette.NEUTRAL010,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(12),
      color: theme.palette.NEUTRAL400,
      borderTop: "1px solid ".concat(theme.palette.NEUTRAL040)
    }
  });
});
var _default = useCardStyles;
exports.default = _default;